import { render } from "./OkrElementsListItem.vue?vue&type=template&id=7834db40&scoped=true"
import script from "./OkrElementsListItem.vue?vue&type=script&lang=js"
export * from "./OkrElementsListItem.vue?vue&type=script&lang=js"

import "./OkrElementsListItem.vue?vue&type=style&index=0&id=7834db40&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7834db40"]])

export default __exports__